export default __webpack_public_path__ + "static/media/large_light_fallback.40ca0872.jpg";